//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FormItemWrapper from './form-item-wrapper';
import emitter from '@/utils/emitter';
import i18n, { translate } from '@/utils/i18n';
import fieldMixin from '@/components/form-designer/form-widget/field-widget/fieldMixin';
export default {
  name: 'input-number-widget',
  componentName: 'FieldWidget',
  //必须固定为FieldWidget，用于接收父级组件的broadcast事件
  mixins: [emitter, fieldMixin, i18n],
  props: {
    field: Object,
    parentWidget: Object,
    parentList: Array,
    indexOfParentList: Number,
    designer: Object,
    designState: {
      type: Boolean,
      default: false
    },
    subFormRowIndex: {
      /* 子表单组件行索引，从0开始计数 */type: Number,
      default: -1
    },
    subFormColIndex: {
      /* 子表单组件列索引，从0开始计数 */type: Number,
      default: -1
    },
    subFormRowId: {
      /* 子表单组件行Id，唯一id且不可变 */type: String,
      default: ''
    }
  },
  components: {
    FormItemWrapper: FormItemWrapper
  },
  inject: ['refList', 'formConfig', 'globalOptionData', 'globalModel'],
  data: function data() {
    return {
      oldFieldValue: null,
      //field组件change之前的值
      fieldModel: undefined,
      rules: []
    };
  },
  computed: {
    contentForReadMode: function contentForReadMode() {
      return this.fieldModel ? this.fieldModel : '--';
    }
  },
  beforeCreate: function beforeCreate() {
    /* 这里不能访问方法和属性！！ */
  },
  created: function created() {
    /* 注意：子组件mounted在父组件created之后、父组件mounted之前触发，故子组件mounted需要用到的prop
         需要在父组件created中初始化！！ */
    this.initFieldModel();
    if (this.fieldModel == '') {
      this.fieldModel = undefined;
    }
    this.registerToRefList();
    this.initEventHandler();
    this.buildFieldRules();
    this.handleOnCreated();
  },
  mounted: function mounted() {
    this.handleOnMounted();
  },
  beforeDestroy: function beforeDestroy() {
    this.unregisterFromRefList();
  },
  methods: {}
};